import _ from 'lodash'

import loadScript from '~/lib/loadScript'

export default function createScriptProxy({
    scriptUrl,
    globalName,
    tagId,
}: {
    scriptUrl: string
    globalName: string
    tagId: string | null
}) {
    return async function proxy(invokePath: string, ...args: any[]) {
        const globalVar = await loadScript(scriptUrl, globalName, tagId)

        return _.invoke(globalVar, invokePath, ...args)
    }
}
